import React, { ChangeEvent, useContext, useEffect, useRef, useState } from "react";
import ICart_Item from "../../../models/ICart_Item";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import styled from "styled-components";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { hasIn } from "lodash";
import OrderEntryService from "../../../services/OrderEntryService";
import SupplierContext from "../../../contexts/SupplierContext";
import IOrder from "../../../models/IOrder";
import IUnit_Of_Measurement_Set from "../../../models/IUnit_Of_Measurement_Set";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";

type Props = {
    cartItem: ICart_Item;
    updateFn: (qty: number) => void;
    readOnly: boolean;
    uomSet?: IUnit_Of_Measurement_Set;
};

export const EcommerceCartItemQty: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);

    const hasInitialRender = useRef(false);
    const hasInitialRenderTwo = useRef(false);
    const [showInput, setShowInput] = useState<boolean>((props.cartItem.uom_set_qty || props.cartItem.qty) > 9);
    const [hasInputChange, setHasInputChange] = useState(false);
    const [itemQty, setItemQty] = useState(props.cartItem.uom_set_qty || props.cartItem.qty || 0);
    const kitItem = !!props.cartItem.parent_cart_item_id;

    useEffect(() => {
        if (hasInitialRender.current) {
            if (props.cartItem.qty !== itemQty && showInput) {
                setItemQty(props.cartItem.uom_set_qty || props.cartItem.qty);
                setHasInputChange(false);
            }

            if (props.cartItem.qty === itemQty) {
                setHasInputChange(false);
            }
        }

        hasInitialRender.current = true;
    }, [props.cartItem.qty]);

    useEffect(() => {
        if (hasInitialRenderTwo.current) {
            const qtyDetail = OrderEntryService.doInventoryValidation(
                props.cartItem.Catalog_Item,
                itemQty,
                [],
                supplierModel,
                {} as IOrder,
                0,
                props.uomSet
            );

            if (qtyDetail.enableAdd) {
                if (qtyDetail.qty >= 10) {
                    setShowInput(true);
                    setHasInputChange(true);
                    setItemQty(qtyDetail.qty);
                } else {
                    setShowInput(false);
                    setItemQty(qtyDetail.qty);
                    props.updateFn(qtyDetail.qty);
                }
            } else {
                setItemQty(qtyDetail.qty);
            }
        }

        hasInitialRenderTwo.current = true;
    }, [itemQty]);

    const handleChange = (e: ChangeEvent<any>) => {
        const value = Number(e.target.value);

        setItemQty(Number(value));
    };

    const updateQty = () => {
        if (hasInputChange) {
            props.updateFn(itemQty);
        }
    };

    const options: { value: number; title: string }[] = [];

    for (let i = 1; i <= 10; ++i) {
        let title = `${i}`;

        if (i === 10) {
            title = "10+";
        }

        let allowOption = true;

        if (props.cartItem.Catalog_Item?.max_order_qty) {
            if (i > props.cartItem.Catalog_Item?.max_order_qty) {
                allowOption = false;
            }
        }

        if (allowOption) {
            options.push({ value: i, title });
        }
    }

    return (
        <EcommerceCartItemQtyDiv>
            {kitItem ? (
                <>
                    <OwLabel title={"qty"} postText={":"} className={"me-2"} isBold={true} />
                    {props.cartItem.qty}
                </>
            ) : (
                <>
                    {!showInput ? (
                        <OwSelectOption
                            name={"qty"}
                            fn={handleChange}
                            options={options}
                            titleProp={"title"}
                            valueProp={"value"}
                            selectedOption={itemQty}
                            selectedOptionProp={"qty"}
                            hasSelectedOptionProp={false}
                            showBlankFirst={false}
                            isDisabled={props.readOnly}
                        />
                    ) : (
                        <EcommerceCartUpdateDiv>
                            <OwFnInput
                                enableDebounce={true}
                                debounceMs={500}
                                fn={handleChange}
                                name={"qty"}
                                value={itemQty}
                                disabled={props.readOnly}
                            />
                            {hasInputChange && !props.readOnly ? (
                                <OwButton className={"ms-2 btn-primary"} title={"update"} fn={updateQty} />
                            ) : null}
                        </EcommerceCartUpdateDiv>
                    )}
                </>
            )}
        </EcommerceCartItemQtyDiv>
    );
};

const EcommerceCartItemQtyDiv = styled.div`
    input,
    select {
        width: 5rem;
    }

    min-width: 5rem;
`;

const EcommerceCartUpdateDiv = styled.div`
    display: flex;
`;
